import React__default from 'react';
import FormInputSearchDropdown from './FormInputSearchDropdown.js';

const InputSearchDropdownWrapper = (props) => {
    const { config: { tag, key, label, placeholder, boldLabel, showErrorIcon, disabled, disablePaste, type, onFocus, onBlur, options: selectOptions, externalDataOptions }, keySuffix, externalData } = props;
    const options = selectOptions ||
        (!!externalDataOptions && !!externalData && !!externalData[externalDataOptions]
            ? externalData[externalDataOptions]
            : []);
    return (React__default.createElement(FormInputSearchDropdown, { tag: tag, name: `${key}${keySuffix || ''}`, label: label, boldLabel: boldLabel, showErrors: true, placeholder: placeholder, showErrorIcon: showErrorIcon, disabled: disabled, disablePaste: disablePaste, type: type, onFocus: onFocus, onBlur: onBlur, options: options }));
};

export { InputSearchDropdownWrapper as default };
//# sourceMappingURL=InputSearchDropdownWrapper.js.map
